import { Component, ContentChild, Input } from '@angular/core';
import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';

import {
    DetailCardBodyDirective,
    DetailCardHeaderDirective,
} from './detail-card-templates.directive';

@Component({
    standalone: true,
    imports: [NgIf, NgClass, NgTemplateOutlet],
    selector: 'qwyk-detail-card',
    templateUrl: './detail-card.component.html',
    styleUrls: ['./detail-card.component.scss'],
})
export class DetailCardComponent {
    @Input()
    public caption?: string;

    @Input()
    public cardClass?: string;

    @ContentChild(DetailCardHeaderDirective, { static: false })
    tplHeader: DetailCardHeaderDirective;
    @ContentChild(DetailCardBodyDirective, { static: false })
    tplBody: DetailCardBodyDirective;
}
